import React from 'react';
import { BenefitsListBlock } from 'patterns/BenefitsListBlock';
import { ContentMediaListBlock } from 'patterns/ContentMediaListBlock';
import { FeaturedCaseStudyBlock } from 'patterns/FeaturedCaseStudyBlock';
import { LogoListBlock } from 'patterns/LogoListBlock';
import { Masthead } from 'patterns/Masthead';
import { Media } from 'patterns/Media';
import { ServiceListBlock } from 'patterns/ServiceListBlock';
import { Shell } from 'patterns/Shell';
import { TestimonialListBlock } from 'patterns/TestimonialListBlock';

import '../scss/main.scss';

function HomePage({
    location: {
        pathname,
    },
}) {
    const data = {
        masthead: {
            title: 'Building modern websites using Gatsby, NextJS, Prismic and more',
            description: [
                {
                    spans: [],
                    text: 'Are you looking for a freelance Jamstack developer to help deliver your project using the latest technologies? Then look no further.',
                    type: 'paragraph',
                },
            ],
        },
        masthead_media: {
            items: [
                {
                    media_image: {
                        alt: '',
                        dimensions: {
                            height: 1288,
                            width: 2576,
                        },
                        url: 'https://images.prismic.io/robsimpson/55248d50-6a91-46ba-b95d-02039a34de2b_home.jpg?auto=compress,format'
                    },
                },
            ],
        },
        dashboard: {
            alignment: 'ltr',
            avatar: {
                alt: '',
                dimensions: {
                    height: 192,
                    width: 192,
                },
                url: 'https://images.prismic.io/robsimpson/c3f1228e-06a6-4599-9138-3e75e4fb6911_bryon-lowen.png?auto=compress,format'
            },
            background: false,
            bio: 'Programme Manager at Dashboard',
            buttonText: 'Visit website',
            buttonUrl: {
                link_type: 'Web',
                url: 'https://dashboard.net/',
            },
            description: 'Dashboard are a tech startup who aim to make industry intelligent, safer, cleaner, and more efficient with their IIoT predictive platform.',
            image: {
                alt: '',
                dimensions: {
                    height: 900,
                    width: 614,
                },
                url: 'https://images.prismic.io/robsimpson/ecb9c4b2-1715-48fe-a891-22b0055a6807_dashboard-home-poster.jpg?auto=compress,format'
            },
            name: 'Bryon Lowen',
            quote: 'We are delighted with the outcome. It is a step-change from our previous website, and we can highly recommend Rob for his approach / web technology expertise / and all-around delivery.',
            stats: [
                {
                    stat_label: {
                        text: 'Performance',
                    },
                    stat_text: {
                        text: '+33%',
                    },
                },
                {
                    stat_label: {
                        text: 'SEO',
                    },
                    stat_text: {
                        text: '+18%',
                    },
                },
                {
                    stat_label: {
                        text: 'Accessibility',
                    },
                    stat_text: {
                        text: '+8%',
                    },
                },
            ],
            title: 'Building a more secure, scalable Jamstack website for Dashboard',
            videoUploadUrl: 'https://prismic-io.s3.amazonaws.com/robsimpson/27e52bed-17ad-42a0-82e8-5b31ae399a12_dashboard-home.mp4',
        },
        benefits: {
            background: false,
            description: 'The Jamstack is a new way of building websites and apps. It does away with the database and leverages third-party services to create fast websites with higher security and a lower cost to scale – great for a business of any size.',
            items: [
                {
                    benefits_description: {
                        text: 'Why wait for pages to build on the fly when you can generate them ahead of time? Jamstack websites are up to 10 times faster than a traditional website',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/ea413853-4dda-44d0-9676-e67645fc968c_benefit-speed.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'Speed',
                    },
                },
                {
                    benefits_description: {
                        text: 'Jamstack websites also gain better search rankings, which means more traffic and more revenue for your business',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/d64a7d79-c01c-4a64-8877-8e00935f5947_benefit-seo.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'SEO',
                    },
                },
                {
                    benefits_description: {
                        text: 'No database, no plugins and a pre-built website means the surface area for attack is massively reduced which results in fewer security expenses',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/69bf2102-eb3a-480d-afeb-50958eb9b3f7_benefit-security.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'Security',
                    },
                },
                {
                    benefits_description: {
                        text: 'Jamstack websites scale with your business and user base, meaning you only have to start paying more when your business and audience grow',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/050a6ab5-3d91-4d34-b8d7-bda55083536f_benefit-scalability.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'Scalability',
                    },
                },
                {
                    benefits_description: {
                        text: 'The carbon footprint for a Jamstack website tends to be smaller than a traditional website as it is not connected to a server amongst other things',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/217fd148-1680-47e2-8170-31c723f6d5d1_benefit-sustainability.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'Sustainability',
                    },
                },
            ],
            title: 'Benefits of the Jamstack',
        },
        services: {
            background: true,
            description: 'I’ll work with you to create a new Jamstack marketing or eCommerce site that works towards your business goals.',
            items: [
                {
                    service_button_text: {
                        text: 'Enquire about a Jamstack marketing website',
                    },
                    service_button_url: {
                        link_type: 'Document',
                        type: 'contact_page',
                        uid: 'contact',
                        url: '/contact',
                    },
                    service_check_item_1: {
                        text: 'Your current marketing website is outdated or isn’t meeting your business goals',
                    },
                    service_check_item_2: {
                        text: 'Your current marketing website is hard to manage, has security problems or is slow',
                    },
                    service_check_item_3: {
                        text: 'You need a new marketing website to promote your product or business to users, stakeholders or investors',
                    },
                    service_image: {
                        alt: '',
                        dimensions: {
                            height: 773,
                            width: 1030,
                        },
                        url: 'https://images.prismic.io/robsimpson/eba8dba3-f35e-42fa-bbfe-fa1e00b250c8_jamstack-markerting-site-small.png?auto=compress,format'
                    },
                    service_price: {
                        text: '£6,450',
                    },
                    service_service: {
                        text: 'Jamstack marketing site',
                    },
                    service_title: {
                        text: 'Jamstack marketing site',
                    },
                },
                {
                    service_button_text: {
                        text: 'Enquire about a Jamstack eCommerce website',
                    },
                    service_button_url: {
                        link_type: 'Document',
                        type: 'contact_page',
                        uid: 'contact',
                        url: '/contact',
                    },
                    service_check_item_1: {
                        text: 'Your current eCommerce website is outdated and needs a redesign',
                    },
                    service_check_item_2: {
                        text: 'Your current eCommerce website isn’t converting or meeting your business goals',
                    },
                    service_check_item_3: {
                        text: 'You need a new eCommerce website to sell your products online',
                    },
                    service_image: {
                        alt: '',
                        dimensions: {
                            height: 773,
                            width: 1030,
                        },
                        url: 'https://images.prismic.io/robsimpson/64640d5c-d053-440d-93c0-578a62d24ec3_jamstack-ecommerce-site-small.png?auto=compress,format'
                    },
                    service_price: {
                        text: '£14,950',
                    },
                    service_service: {
                        text: 'Jamstack eCommerce site',
                    },
                    service_title: {
                        text: 'Jamstack eCommerce site',
                    },
                },
            ],
            title: 'What type of project do you need help with?',
        },
        kinta: {
            alignment: 'rtl',
            avatar: {
                alt: '',
                dimensions: {
                    height: 192,
                    width: 192,
                },
                url: 'https://images.prismic.io/robsimpson/5dca609e-6c67-4921-90c1-8a0144f87837_max-feider.png?auto=compress,format'
            },
            background: false,
            bio: 'VP Operations at Kinta AI',
            buttonText: 'Visit website',
            buttonUrl: {
                link_type: 'Web',
                url: 'https://kinta-ai.com/',
            },
            description: 'Kinta AI are a Silicon Valley tech startup, they develop software which uses AI at its core to help manufacturers conquer the complexity of the modern factory.',
            image: {
                alt: '',
                dimensions: {
                    height: 900,
                    width: 614,
                },
                url: 'https://images.prismic.io/robsimpson/561e3c0a-1d7b-4019-bcf1-a2694aed162c_kinta-home-poster.jpg?auto=compress,format'
            },
            name: 'Max Feider',
            quote: 'We love Rob’s redesign of our website. He did an awesome job gathering our thoughts and requests in a structured and efficient process, came up with creative ideas and solutions and delivered a great end-product on a tight deadline. Well done!',
            stats: [
                {
                    stat_label: {
                        text: 'Performance',
                    },
                    stat_text: {
                        text: '+24%',
                    },
                },
                {
                    stat_label: {
                        text: 'SEO',
                    },
                    stat_text: {
                        text: '+9%',
                    },
                },
                {
                    stat_label: {
                        text: 'Accessibility',
                    },
                    stat_text: {
                        text: '+12%',
                    },
                },
            ],
            title: 'Refreshing Kinta AI’s web presence with a newly designed Jamstack website',
            videoUploadUrl: 'https://prismic-io.s3.amazonaws.com/robsimpson/0fbb62f3-b79d-4441-b529-02a82f354233_kinta-home.mp4',
        },
        technologies: {
            background: false,
            description: 'Modern technologies I use to push your business forward.',
            items: [
                {
                    logo_image: {
                        alt: 'NextJS',
                        dimensions: {
                            height: 48,
                            width: 78,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/07d83a4e-32f1-42d5-994c-c655e6362bf4_NextJS.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://nextjs.org/',
                    },
                    logo_size: {
                        text: 'large',
                    },
                    logo_size_mobile: {
                        text: 'xlarge',
                    },
                },
                {
                    logo_image: {
                        alt: 'Gatsby',
                        dimensions: {
                            height: 40,
                            width: 153,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/aac70c63-d427-4889-9ded-6b4544629b09_Gatsby.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://www.gatsbyjs.com/',
                    },
                    logo_size: {
                        text: 'medium',
                    },
                    logo_size_mobile: {
                        text: 'large',
                    },
                },
                {
                    logo_image: {
                        alt: 'Prismic',
                        dimensions: {
                            height: 40,
                            width: 152,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/1416ec99-c8f0-415f-8832-05f6cd29f895_Prismic.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://prismic.io/',
                    },
                    logo_size: {
                        text: 'medium',
                    },
                    logo_size_mobile: {
                        text: 'large',
                    },
                },
                {
                    logo_image: {
                        alt: 'Shopify',
                        dimensions: {
                            height: 40,
                            width: 134,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/5485de44-da3f-4750-9e6c-2ec96de23f3c_Shopify.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://www.shopify.co.uk/',
                    },
                    logo_size: {
                        text: 'medium',
                    },
                    logo_size_mobile: {
                        text: 'large',
                    },
                },
                {
                    logo_image: {
                        alt: 'Vercel',
                        dimensions: {
                            height: 32,
                            width: 136,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/322cea98-fdd1-48bc-8115-536e3404e1e9_Vercel.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://vercel.com/',
                    },
                    logo_size: {
                        text: 'small',
                    },
                    logo_size_mobile: {
                        text: 'medium',
                    },
                },
                {
                    logo_image: {
                        alt: 'Netlify',
                        dimensions: {
                            height: 40,
                            width: 144,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/e87e7934-70f9-47b6-b321-6a689a3780ae_Netlify.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://www.netlify.com/',
                    },
                    logo_size: {
                        text: 'medium',
                    },
                    logo_size_mobile: {
                        text: 'large',
                    },
                },
            ],
            title: 'Technologies I use',
        },
        testimonials: {
            background: true,
            description: 'Hearing how happy my clients are is the best part of what I do.',
            items: [
                {
                    testimonial_bio: {
                        text: 'Co-Founder at Howl',
                    },
                    testimonial_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/c4375679-f583-43e4-812c-cb23c567318b_david-laub.png?auto=compress,format'
                    },
                    testimonial_quote: {
                        text: 'Rob has a unique ability to understand user experience needs, produce aesthetically pleasing designs, and write maintainable / modular code. To anyone in search of a highly creative and experienced developer for their next project - look no further.',
                    },
                    testimonial_name: {
                        text: 'David Laub',
                    },
                },
                {
                    testimonial_bio: {
                        text: 'Managing Director at Unfold',
                    },
                    testimonial_image: {
                        alt: '',
                        dimensions: {
                            height: 200,
                            width: 200,
                        },
                        url: 'https://images.prismic.io/robsimpson/d69bcdff-d2e8-4aa1-8aaa-41de52ec788d_harry-cobbold.jpg?auto=compress,format'
                    },
                    testimonial_quote: {
                        text: 'Working with Rob is fantastic, he communicates well and delivers a very high quality of work. Whether building from scratch or picking up a legacy codebase, he’s been quick and effective - highly recommended!',
                    },
                    testimonial_name: {
                        text: 'Harry Cobbold',
                    },
                },
            ],
            itemsPerRow: '2',
            title: 'Client success stories',
        },
        about: {
            items: [
                {
                    content_media_alignment: 'ltr',
                    content_media_button_text: {
                        text: 'Find out more about me',
                    },
                    content_media_button_url: {
                        link_type: 'Document',
                        type: 'about',
                        uid: 'about',
                    },
                    content_media_content: {
                        text: 'I’m Rob Simpson, a freelance Jamstack developer and UI designer from Oxfordshire, UK. With over 8 years of experience in the industry, I’ve built a multitude of projects from large scale eCommerce websites to creative campaign websites for clients like Twinings, HMV and Oxford University.',
                    },
                    content_media_image: {
                        alt: '',
                        dimensions: {
                            height: 3024,
                            width: 4032,
                        },
                        url: 'https://images.prismic.io/robsimpson/b654c40f-f586-4b69-8fdb-9ff3018fa444_about-office.jpg?auto=compress,format'
                    },
                    content_media_title: {
                        text: 'Who am I?',
                    },
                },
            ],
        },
    };

    return (
        <Shell
            pageDescription="Rob is a Jamstack developer and UI designer based in Oxfordshire UK focused on building modern websites using Gatsby, NextJS, Prismic, DatoCMS and more."
            pageSocialImage=""
            pageTitle="Freelance Jamstack developer, Oxfordshire UK"
            pathname={pathname}
        >
            <Masthead
                description={data.masthead.description}
                title={data.masthead.title}
            />
            <Media
                items={data.masthead_media.items}
            />
            <FeaturedCaseStudyBlock
                alignment={data.dashboard.alignment}
                avatar={data.dashboard.avatar}
                background={data.dashboard.background}
                bio={data.dashboard.bio}
                buttonText={data.dashboard.buttonText}
                buttonUrl={data.dashboard.buttonUrl}
                description={data.dashboard.description}
                image={data.dashboard.image}
                name={data.dashboard.name}
                quote={data.dashboard.quote}
                stats={data.dashboard.stats}
                title={data.dashboard.title}
                videoUploadUrl={data.dashboard.videoUploadUrl}
            />
            <BenefitsListBlock
                background={data.benefits.background}
                description={data.benefits.description}
                items={data.benefits.items}
                title={data.benefits.title}
            />
            <ServiceListBlock
                background={data.services.background}
                description={data.services.description}
                items={data.services.items}
                title={data.services.title}
            />
            <FeaturedCaseStudyBlock
                alignment={data.kinta.alignment}
                avatar={data.kinta.avatar}
                background={data.kinta.background}
                bio={data.kinta.bio}
                buttonText={data.kinta.buttonText}
                buttonUrl={data.kinta.buttonUrl}
                description={data.kinta.description}
                image={data.kinta.image}
                name={data.kinta.name}
                quote={data.kinta.quote}
                stats={data.kinta.stats}
                title={data.kinta.title}
                videoUploadUrl={data.kinta.videoUploadUrl}
            />
            <LogoListBlock
                background={data.technologies.background}
                description={data.technologies.description}
                items={data.technologies.items}
                title={data.technologies.title}
            />
            <TestimonialListBlock
                background={data.testimonials.background}
                description={data.testimonials.description}
                items={data.testimonials.items}
                itemsPerRow={data.testimonials.itemsPerRow}
                title={data.testimonials.title}
            />
            <ContentMediaListBlock
                items={data.about.items}
            />
        </Shell>
    );
}

export default HomePage;
